export class InvGoodsIssueDtlModel {
  ItemId: number;
  ItemUid: string;
  ItemName: string;
  QuantitySum?: number;
}
